export default "__VITE_ASSET__ouDh3bQN__"